import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Media from 'builder/styles/media'
import { FontWeights } from 'builder/styles/typography'
import { getLineHeightRatio } from 'builder/components/SubscriptionCancellationFormNew/common/utils'

export const BackButton = styled.span`
  font-family: 'TT Commons';
  ${FontWeights.Medium};
  text-align: center;
  color: ${Colors.Blue50};
  margin-left: 4px;

  ${Media.Tablet`
    font-size: 19px;
    line-height: ${getLineHeightRatio(24, 19)};
  `}

  ${Media.Phone`
    font-size: 16px;
    line-height: ${getLineHeightRatio(16, 20)};
  `}
`
